<script setup lang="ts">
    import { inject, ref, watch } from 'vue';
    import FormTextArea from '@shared/components/Form/FormTextArea.vue';
    import RichEditor from '@shared/components/RichEditor/RichEditor.vue';
    import EventEditorDetailsNav from '@views/Event/EventEditor/Details/EventEditorDetailsNav.vue';
    import { eventKey, queueEventPropertyKey, saveEventPropertyIfChangedKey, canEditKey } from '@views/Event/EventEditor/event-editor-keys';

    const props = defineProps<{
        eventId: string;
    }>();

    const event = inject(eventKey)!;
    const canEdit = inject(canEditKey)!;
    const queueEventProperty = inject(queueEventPropertyKey)!;
    const saveEventPropertyIfChanged = inject(saveEventPropertyIfChangedKey)!;

    const name = ref('');
    const publicDescription = ref('');

    watch(
        () => event.value?.Name,
        (value) => (name.value = value ?? ''),
        { immediate: true }
    );
    watch(
        () => event.value?.PublicDescription,
        (value) => (publicDescription.value = value ?? ''),
        { immediate: true }
    );

    function onDescriptionChange(newValue: string) {
        publicDescription.value = newValue;
        queueEventProperty('PublicDescription', newValue, $Resources.EventPublicDescription);
    }
</script>

<template>
    <div v-if="event" class="max-700">
        <h2 class="h3 m-0-t">{{ $Resources.EventNavDetailsGeneral }}</h2>

        <FormTextArea
            class="form-group form-group-h4"
            :label="$Resources.EventNameLabel"
            v-model="name"
            :placeholder="$Resources.EventNamePlaceholder"
            :disableNewlines="true"
            :disabled="!canEdit"
            :maxlength="255"
            @onBlur="saveEventPropertyIfChanged('Name', name, $Resources.EventNameLabel)" />

        <div class="form-group">
            <h3 class="h5 m-xs-b">{{ $Resources.EventPublicDescription }}</h3>
            <p>{{ $Resources.EventPublicDescriptionInfoText }}</p>
            <RichEditor :modelValue="publicDescription" :disableEditing="!canEdit" @update:modelValue="onDescriptionChange"></RichEditor>
        </div>

        <EventEditorDetailsNav v-if="event" :eventId="props.eventId" />
    </div>
</template>
